if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
  // console.log('Scroll restoration set to manual');
}
document.addEventListener('DOMContentLoaded', function() {
  window.scrollTo(0, 0);
  // console.log('Scrolled to top on DOMContentLoaded');
});
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    window.scrollTo(0, 0);
  }
});



gsap.registerPlugin(ScrollTrigger);

function initWorkPieceHoverEffect() {
  const workPieces = document.querySelectorAll(".work-piece");

  if (workPieces.length === 0) return; // Exit if no work pieces exist

  workPieces.forEach((workPiece) => {
    // Check if background is already applied to prevent duplication
    if (!workPiece.querySelector(".work-piece-bg")) {
      let bg = document.createElement("div");
      bg.classList.add("work-piece-bg");
      bg.style.backgroundImage = workPiece.style.backgroundImage;
      workPiece.appendChild(bg);

      gsap.set(bg, {
        position: "absolute",
        inset: 0,
        backgroundSize: "cover",
        backgroundPosition: "center",
        zIndex: "-1",
      });

      workPiece.addEventListener("mouseenter", () => {
        gsap.to(bg, {
          scale: 1.05, // Zoom background
          duration: 0.5,
          ease: "power2.out",
        });
      });

      workPiece.addEventListener("mouseleave", () => {
        gsap.to(bg, {
          scale: 1, // Reset background
          duration: 0.5,
          ease: "power2.out",
        });
      });
    }
  });
}

function handleShowcaseButtonClick() {
  jQuery(document).ready(function ($) {
    // Handle button click
    $(document).on('click', '.showcase-btn', function (e) {
      e.preventDefault();
      var postId = $(this).data('post-id');

      $.ajax({
        url: ajax_url.ajax_url,
        type: 'POST',
        data: {
          action: 'get_post_details',
          post_id: postId
        },
        beforeSend: function () {
          // Set the modal to visible and animate it
          gsap.set('.js-work-sample-modal', { display: 'block', opacity: 0 });
          gsap.to('.js-work-sample-modal', {
            y: '0%',
            opacity: 1,
            duration: 0.8,
            ease: 'power2.out',
            onComplete: function () {
              // Animate the inner wrapper after the modal is fully visible
              gsap.fromTo(
                '.js-work-sample-wrapper',
                { y: '-50%', opacity: 0 },
                { y: '0%', opacity: 1, duration: 0.6, ease: 'power2.out' }
              );
            }
          });
        },
        success: function (response) {
          // Populate the modal with AJAX response
          $('.js-work-sample-wrapper').html(response.data);

          // Initialize slider functionality after content is loaded
          initSlider();
        },
        error: function (xhr, status, error) {
          $('.js-work-sample-wrapper').html('<p>An error occurred. Please try again later.</p>');
          console.error('AJAX Error:', status, error);
        }
      });
    });

    // Play button click to play video, pausing any others
    $(document).on("click", ".play-button", function () {
      var showcaseVideoId = $(this).data("video-id");
      var showcaseVideo = $(".custom-video[data-video-id='" + showcaseVideoId + "']")[0];

      // Pause all other videos before playing the new one
      $(".custom-video").each(function () {
        if (!this.paused && this !== showcaseVideo) {
          this.pause();
          var otherId = $(this).data("video-id");
          $(".play-button[data-video-id='" + otherId + "']").removeClass("hidden");
        }
      });

      // Play/Pause the clicked video
      if (showcaseVideo.paused) {
        showcaseVideo.play();
        $(this).addClass("hidden"); // Hide play button
      }
    });

    // Pause video when clicking on the video itself
    $(document).on("click", ".custom-video", function () {
      var showcaseVideoId = $(this).data("video-id");
      var button = $(".play-button[data-video-id='" + showcaseVideoId + "']");
      if (!this.paused) {
        this.pause();
        button.removeClass("hidden"); // Show play button again
      }
    });

    function initSlider() {
      let count = 0;
      const targets = document.querySelectorAll(".box");
      const nextButton = document.querySelector("#nextButton");
      const prevButton = document.querySelector("#prevButton");

      let startX = 0;
      let endX = 0;
      const threshold = 50; // Minimum distance required for a swipe

      // Set initial positions for the boxes
      gsap.set(targets, { xPercent: 100, opacity: 0 });
      gsap.set(targets[0], { xPercent: 0, opacity: 1 });

      // Next slide
      function slideNext() {
        // Stop any playing video in the current slide
        var currentSlide = targets[count];
        var video = currentSlide.querySelector(".custom-video");
        var playButton = currentSlide.querySelector(".play-button");
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0;
          if (playButton) {
            playButton.classList.remove("hidden");
          }
          // console.log("Stopped video in current slide before slideNext");
        }

        gsap.to(targets[count], {
          xPercent: -100,
          opacity: 0,
          duration: 1.2,
          zIndex: -10,
          ease: "power2.out",
        });
        count = (count + 1) % targets.length;
        gsap.fromTo(
          targets[count],
          { xPercent: 100, opacity: 0, zIndex: 10 },
          { xPercent: 0, opacity: 1, duration: 1.2, ease: "power2.out" }
        );
      }

      // Previous slide
      function slidePrev() {
        // Stop any playing video in the current slide
        var currentSlide = targets[count];
        var video = currentSlide.querySelector(".custom-video");
        var playButton = currentSlide.querySelector(".play-button");
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0;
          if (playButton) {
            playButton.classList.remove("hidden");
          }
          // console.log("Stopped video in current slide before slidePrev");
        }

        gsap.to(targets[count], {
          xPercent: 100,
          opacity: 0,
          duration: 1.2,
          zIndex: -10,
          ease: "power2.out",
        });
        count = (count - 1 + targets.length) % targets.length;
        gsap.fromTo(
          targets[count],
          { xPercent: -100, opacity: 0, zIndex: 10 },
          { xPercent: 0, opacity: 1, duration: 1.2, ease: "power2.out" }
        );
      }

      // Swipe handlers with target check
      function handleTouchStart(e) {
        if (e.target.closest('.play-button')) {
          return;
        }
        startX = e.touches[0].clientX;
      }

      function handleTouchMove(e) {
        if (e.target.closest('.play-button')) {
          return;
        }
        endX = e.touches[0].clientX;
      }

      function handleTouchEnd(e) {
        if (e.target.closest('.play-button')) {
          return;
        }
        const diffX = startX - endX;
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            slideNext();
          } else {
            slidePrev();
          }
        }
      }

      // Attach touch event listeners to the slider container
      const sliderContainer = document.querySelector(".box-container");
      sliderContainer.addEventListener("touchstart", handleTouchStart);
      sliderContainer.addEventListener("touchmove", handleTouchMove);
      sliderContainer.addEventListener("touchend", handleTouchEnd);

      // Attach event listeners for buttons
      nextButton.addEventListener("click", slideNext);
      prevButton.addEventListener("click", slidePrev);
    }

    // Handle modal close button
    $(document).on('click', '.js-modal-close', function () {
      gsap.to('.js-work-sample-wrapper', {
        y: '-50%',
        opacity: 0,
        duration: 0.5,
        ease: 'power2.in',
        onComplete: function () {
          gsap.to('.js-work-sample-modal', {
            y: '-100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power2.in',
            onComplete: function () {
              // Hide the modal and clear content
              gsap.set('.js-work-sample-modal', { display: 'none' });
              $('.js-work-sample-wrapper').empty();
            }
          });
        }
      });
    });
  });
}

function newLineAnimation(lineSelector, options = {}) {
  const lines = gsap.utils.toArray(lineSelector);
  lines.forEach((line, index) => {
    const lineHeight = line.offsetHeight;
    const dynamicEnd = options.end || `+=${lineHeight * 1.5}`;
    gsap.set(line, { transformOrigin: options.transformOrigin || "top center", scaleY: 0 });
    gsap.fromTo(
      line,
      { scaleY: 0 },
      {
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          trigger: line,
          start: options.start || "top bottom",
          end: dynamicEnd,
          scrub: true,
          markers: options.markers || false,
        },
      }
    );
  });
}
function FFLlineAnimation(lineSelector, options = {}) {
  newLineAnimation(lineSelector, options);
}
function animateHighlightText() {
  const headings = gsap.utils.toArray(".highlight-text-heading .highlighted, .has-highlight strong, .services-rendered, .capabilities-sm strong");

  headings.forEach((el) => {
    // Highlight Animation
    gsap.fromTo(
      el,
      { '--highlight-width': "0%" },
      {
        '--highlight-width': "100%",
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 75%",
          end: "top 50%",
          scrub: false, // Removed scrub to avoid conflicts
          toggleActions: "play none none reverse", // Ensure it only plays once
        },
      }
    );
  });
}
function newFadeUpOnScroll(targetClass, options = {}) {
  const elements = gsap.utils.toArray(`.${targetClass}`);

  elements.forEach((el, index) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: options.startY || 50 },
      {
        opacity: 1,
        y: 0,
        duration: options.duration || 1.2,
        ease: options.ease || "power2.out",
        scrollTrigger: {
          trigger: el,
          start: options.start || "top 85%",
          end: options.end || "top 50%",
          toggleActions: options.toggleActions || "play none none reverse",
          markers: options.markers || false,
        },
      }
    );
  });
}
function fadeUpAndControlVideo(options = {}) {
  const videos = document.querySelectorAll(".video-proj");

  if (videos.length === 0) return;

  videos.forEach((video) => {
    const section = video.closest(".fade-up");
    if (!section) return;

    gsap.fromTo(
      section,
      { opacity: 0, y: options.startY || 50 },
      {
        opacity: 1,
        y: 0,
        duration: options.duration || 1.2,
        ease: options.ease || "power2.out",
        scrollTrigger: {
          trigger: section,
          start: options.start || "top 85%",
          end: options.end || "bottom 20%",
          toggleActions: "play none none reverse",
          onEnter: () => {
            video.currentTime = 0;
            video.play();
          },
          onLeave: () => video.pause(),
          onEnterBack: () => {
            video.currentTime = 0;
            video.play();
          },
          onLeaveBack: () => video.pause(),
          markers: options.markers || false,
        },
      }
    );
  });
}
function capabilitiesWaveFadeIn() {
  const blocks = gsap.utils.toArray(".capabilities-icon-block");
  if (blocks.length === 0) return;
  gsap.fromTo(
    blocks,
    { opacity: 0, y: 50 },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".capabilities-icon-block",
        start: "top 85%",
        end: "top 50%",
        toggleActions: "play none none reverse",
        markers: false,
      },
    }
  );
}
function clientLogoWaveFadeIn() {
  const blocks = gsap.utils.toArray(".logo-wrap");
  if (blocks.length === 0) return;
  gsap.fromTo(
    blocks,
    { opacity: 0, y: 50 },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".logo-wrap",
        start: "top 85%",
        end: "top 50%",
        toggleActions: "play none none reverse",
        markers: false,
      },
    }
  );
}

function newAnimateBgSvgPaths(svgSelector) {
  const svgElements = document.querySelectorAll(svgSelector);

  if (!svgElements.length) return; // Exit if no SVGs found

  gsap.utils.toArray(svgElements).forEach((svgElement) => {
    const bgSvgPaths = [...svgElement.querySelectorAll("path")];

    if (bgSvgPaths.length === 0) return; // Exit if no paths are found inside the SVG

    const totalPaths = bgSvgPaths.length;
    const offset = 20 / totalPaths; // Spread animation over the scroll range

    bgSvgPaths.forEach((path, index) => {
      gsap.fromTo(
        path,
        { opacity: 0, scale: 0.95 }, // Start with fade-out and slight scale-down
        {
          opacity: 1, // Fully visible
          scale: 1, // Return to full scale
          duration: 1.5, // Smooth animation
          ease: "power3.out", // Smooth easing effect
          force3D: true, // Ensure hardware acceleration
          overwrite: true, // Prevent conflicts
          scrollTrigger: {
            trigger: svgElement, // Trigger animation on the SVG
            start: `${25 + offset * index}% center`, // Start dynamically based on index
            end: `${25 + offset * (index + 1)}% center`, // End after the start of the next path
            scrub: true, // Sync animation with scroll
            id: `${svgSelector}-path-${index}`, // Ensure unique ScrollTrigger ID
          },
        }
      );
    });
  });

  // Ensure ScrollTrigger recalculates elements after setting animations
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);
}

function initializeVideoPlayer() {
  const container = document.querySelector('.full-video'); // Full video container
  const video = document.querySelector('#video-main'); // Video element
  const poster = document.querySelector('#poster'); // Poster image
  const button = document.querySelector('#video-toggle'); // Play/Pause button

  // Ensure elements exist before proceeding
  if (!container || !video || !poster || !button) {
    console.warn('Skipping initialization: Missing required elements');
    return;
  }

  let isPlaying = false; // Track if the video is playing

  // Function to play or pause video
  function toggleVideo() {
    if (!isPlaying) {
      video.classList.remove('hidden'); // Ensure video is visible
      poster.classList.add('hidden'); // Hide poster
      video.play()
        .then(() => {
          isPlaying = true;
        })
        .catch(error => console.warn("Playback failed:", error)); // Catch play() errors
    } else {
      video.pause();
      isPlaying = false;
      poster.classList.remove('hidden'); // Show poster again
      video.classList.add('hidden'); // Hide video
    }
  }

  // Play/Pause button event
  button.addEventListener('click', toggleVideo);

  // When video ends, show poster again
  video.addEventListener('ended', function () {
    isPlaying = false;
    poster.classList.remove('hidden'); // Show poster
    video.classList.add('hidden'); // Hide video
  });

  // Ensure video is hidden initially
  video.classList.add('hidden');
}
function initializePinnedSwiper({
  swiperSelector = ".case-study-carousel",
  wrapperSelector = ".case-study-carousel-wrapper",
  paginationSelector = ".swiper-pagination",
  offsetFromTop = "20vh",
}) {
  const swiperElement = document.querySelector(swiperSelector);
  const wrapperElement = document.querySelector(wrapperSelector);

  if (!swiperElement || !wrapperElement) {
    console.error("Missing elements:", { swiperElement, wrapperElement });
    return;
  }

  // console.log("Initializing Pinned Swiper...");

  const swiper = new Swiper(swiperSelector, {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    pagination: { el: paginationSelector, clickable: true },
  });

  const mediaQuery = window.matchMedia("(max-width: 768px)");

  function createScrollTriggers() {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // Kill existing triggers before re-creating

    if (!mediaQuery.matches) {
      // console.log("Creating ScrollTriggers...");

      ScrollTrigger.create({
        trigger: wrapperSelector,
        start: `top ${offsetFromTop}`,
        end: () => `+=${swiper.slides.length * window.innerHeight * 0.5}`,
        pin: true,
        scrub: true,
        onUpdate: (self) => {
          const progress = self.progress * (swiper.slides.length - 1);
          swiper.slideTo(Math.round(progress));
        },
      });
    }
  }

  createScrollTriggers(); // Initialize on load

  mediaQuery.addEventListener("change", createScrollTriggers); // Reinitialize on resize
}
function animateSvgPaths(svgSelector, fillColor) {
  const svgElement = document.querySelector(svgSelector);

  // Check if the SVG exists before proceeding
  if (!svgElement) return;

  const svgPaths = svgElement.querySelectorAll("path");

  if (svgPaths.length === 0) return; // Ensure there are paths to animate

  svgPaths.forEach((path) => {
    const pathLength = path.getTotalLength(); // Get the length of the path

    // Set initial stroke and fill styles
    gsap.set(path, {
      strokeDasharray: pathLength,
      strokeDashoffset: pathLength, // Path is hidden initially
      fill: "transparent", // Path fill is transparent initially
    });

    // Stroke animation tied to scroll
    gsap.fromTo(
      path,
      { strokeDashoffset: pathLength }, // Start fully hidden
      {
        strokeDashoffset: 0, // Fully drawn
        ease: "none",
        duration: 2,
        scrollTrigger: {
          trigger: path, // Trigger when the path enters the viewport
          start: "top 80%", // Animation starts earlier for better visibility
          end: "top 60%", // Animation ends before reaching the center
          scrub: true, // Synchronizes animation with scroll position
        },
      }
    );

    // Fill animation to ensure no transparency issues
    gsap.to(path, {
      fill: fillColor, // Final fill color from the parameter
      duration: 1, // Duration of the fill animation
      ease: "power2.out", // Smooth easing
      scrollTrigger: {
        trigger: path, // Trigger when the path enters the viewport
        start: "top 70%", // Start fading the fill earlier
        end: "top 55%", // Fill animation ends before the SVG hits the center
        scrub: true, // Sync with scroll for smooth effect
      },
    });
  });
}
function animateInteriorHeroSection() {
  const $header = document.querySelector("[data-content-area=interior-hero]");
  if (!$header) return; // Exit if hero header doesn't exist

  const $image = $header.querySelector(".image");
  const $title = $header.querySelector(".title");
  const $highlight = $header.querySelector(".highlight"); // Assuming the highlighted element exists in the hero section

  if (!$image || !$title) return; // Exit if required elements are missing

  // Prevent other animations on the same elements
  gsap.killTweensOf([$image, $title, $highlight].filter(Boolean)); // Ensure no undefined values

  // Set initial states using GSAP
  gsap.set($image, { autoAlpha: 0 }); // Hide image
  gsap.set($title, { autoAlpha: 0, y: 50 }); // Hide title and move it down

  // Animation timeline
  const timeline = gsap.timeline();

  // Fade in the image
  timeline.to($image, { autoAlpha: 1, duration: 1 });

  // Fade in the text from the bottom
  timeline.to($title, { autoAlpha: 1, y: 0, duration: 1, ease: "power2.out" }, "-=0.5");

  // Highlight animation if element exists
  if ($highlight) {
    timeline.to($highlight, {
      "--highlight-width": "100%",
      duration: 0.5, // Adjusted for smoother effect
      ease: "power1.out",
    });
  }
}

function animateStats(selector = ".stat", duration = 2000) {
  const counters = document.querySelectorAll(selector);

  const options = {
    root: null, // Viewport
    threshold: 0.5 // Trigger when 50% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const stat = entry.target;
        const text = stat.innerText.trim();

        // Extract number (supports time, %, commas, etc.)
        const match = text.match(/([\d,:\.]+)/);
        if (!match) return;

        const originalNumber = match[0]; // Extracted numeric part
        const isTimeFormat = originalNumber.includes(":"); // Detects if it's a time format

        if (isTimeFormat) {
          // Handle time format "mm:ss"
          let [minutes, seconds] = originalNumber.split(":").map(num => parseInt(num, 10));
          let totalSeconds = minutes * 60 + seconds; // Convert to total seconds
          let currentSeconds = 0;

          const increment = totalSeconds / (duration / 16); // Frame-based increment

          const updateCounter = () => {
            if (currentSeconds < totalSeconds) {
              currentSeconds += increment;

              let newMinutes = Math.floor(currentSeconds / 60);
              let newSeconds = Math.floor(currentSeconds % 60).toString().padStart(2, '0');

              let newTime = `${newMinutes}:${newSeconds}`;
              stat.innerText = text.replace(originalNumber, newTime);

              requestAnimationFrame(updateCounter);
            } else {
              stat.innerText = text.replace(originalNumber, originalNumber); // Set final time
            }
          };

          updateCounter();
        } else {
          // Regular number handling
          const target = parseFloat(originalNumber.replace(/,/g, '')); // Remove commas
          let current = 0; // Start from 0
          const increment = target / (duration / 16); // Frame-based increment

          const updateCounter = () => {
            if (current < target) {
              current += increment;
              let newNumber = Math.floor(current).toLocaleString(); // Format with commas
              stat.innerText = text.replace(originalNumber, newNumber);
              requestAnimationFrame(updateCounter);
            } else {
              stat.innerText = text.replace(originalNumber, target.toLocaleString()); // Final value
            }
          };

          updateCounter();
        }

        observer.unobserve(stat); // Stop observing after animation
      }
    });
  }, options);

  counters.forEach(counter => observer.observe(counter));
}

function statScroller() {
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
  const mm = gsap.matchMedia();
  const caseStudyWrapper = document.querySelector(".case-study-stat-wrapper");
  const sections = gsap.utils.toArray(".content-wrapper .content");
  const buttons = document.querySelectorAll(".sidebar-col button");
  const contentWrapper = document.querySelector(".content-wrapper");
  const dividers = document.querySelectorAll(".v-divide");
  const sectionBorder = document.querySelectorAll(".stat-top-wrapper");
  const getWidthElement = document.querySelector(".get-width-of-element");

  if (!contentWrapper || sections.length === 0 || !getWidthElement) return;
  mm.add("(min-width: 991px)", () => {
    function animateDividers() {
      ScrollTrigger.create({
          trigger: sections[0], // Adjust if you need it to apply to multiple sections
          start: "left 90%", // Trigger when section enters the viewport
          end: "left 10%", // Allows smooth reversing when scrolling up
          toggleActions: "play none none reverse", // Plays forward and reverses on scroll up
          onEnter: () => {
            gsap.to(dividers, {
              "--divider-height": "100%",
              "--divider-opacity": 1,
              duration: 1,
              ease: "power2.out"
            });
            gsap.to(sectionBorder, {
              "--divider-width": "100%",
              "--divider-opacity": "100%",
              duration: 1,
              ease: "power2.out",
            });
          },
          onLeaveBack: () => {
            gsap.to(dividers, {
              "--divider-height": "0%",
              "--divider-opacity": 0,
              duration: 1,
              ease: "power2.out"
            });
            gsap.to(sectionBorder, {
              "--divider-width": "0%",
              "--divider-opacity": 0,
              duration: 1,
              ease: "power2.out",
            });
          }
      });
    }
    animateDividers();
    let totalWidth = sections.reduce(
      (sum, section) => sum + section.offsetWidth,
      0
    );

    let horizontalScroll = gsap.to(sections, {
      x: () => {
        let updatedTotalWidth = sections.reduce((sum, section) => sum + section.offsetWidth, 0);
        return `-${updatedTotalWidth - getWidthElement.getBoundingClientRect().width}`;
      },
      ease: "none",
      scrollTrigger: {
        id: "x",
        trigger: ".case-study-stat-wrapper",
        pin: true,
        scrub: 1,
        end: () => {
          let updatedTotalWidth = sections.reduce((sum, section) => sum + section.offsetWidth, 0);
          return `+=${updatedTotalWidth}`;
        },
        invalidateOnRefresh: true,
        onUpdate: (self) => {
              const progress = self.progress;
              const activeIndex = Math.round(progress * (sections.length - 1));
              // **Remove active class from all buttons**
              sections.forEach(section => section.classList.remove("active"));
              if (sections[activeIndex]) {
                sections[activeIndex].classList.add("active");
              }

              buttons.forEach(btn => btn.classList.remove("active"));
              if (buttons[activeIndex]) {
                buttons[activeIndex].classList.add("active");
              }
        }
      }
    });


    function getScrollPosition(animation, progress) {
      let p = gsap.utils.clamp(0, 1, progress || 0),
        st = animation.scrollTrigger,
        range = st.end - st.start,
        position = st.start + range * p;
      return gsap.utils.clamp(0, st.end, position);
    }

    // **Button Click to Scroll & Set Active Class**
    buttons.forEach((button, index) => {
      let progress = index / (buttons.length - 1);

      button.addEventListener("click", function (event) {
        event.preventDefault();
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
        gsap.to(window, {
          scrollTo: () => getScrollPosition(horizontalScroll, progress),
          duration: 1
        });
      });
    });


  });
}
function teamTopContentCarousel() {
  const teamMobile = document.querySelector(".mobileTeamWrapper");

  if (!teamMobile) return;

  const teamSwiper = new Swiper(".team-swiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
      el: ".swiper-pagination",
    },
    on: {
      slideChangeTransitionEnd: function () {
        document.querySelectorAll(".swiper-slide").forEach(slide => {
          const highlight = slide.querySelector(".mobile-content h2 span::after");

          if (slide.classList.contains("swiper-slide-active")) {
            // **Reset animation by removing and re-adding the class**
            slide.classList.remove("animation-active");
            void slide.offsetWidth; // **Force Reflow**
            slide.classList.add("animation-active");
          }
        });
      }
    }
  });

}
function teamTitleHighlight() {
  const elements = document.querySelectorAll(".team-highlight .highlighted");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          gsap.to(entry.target, {
            '--highlight-width': "100%",
            duration: 1.5,
            ease: "power2.out",
          });
        } else {
          gsap.to(entry.target, {
            '--highlight-width': "0%",
            duration: 1.5,
            ease: "power2.out",
          });
        }
      });
    },
    {
      root: null, // Uses viewport as the root
      threshold: 0.6, // ✅ Fires only when 60% of the element is in view
    }
  );

  elements.forEach((el) => observer.observe(el));
}

let parallaxInstances = [];
function initUkiyo() {
  // Select all elements with the .ukiyo class
  const parallaxElements = document.querySelectorAll('.ukiyo');

  // Initialize Ukiyo.js for each element
  parallaxElements.forEach((parallax) => {
    const ukiyoInstance = new Ukiyo(parallax, {
      scale: 1.1,
      speed: 1.7,
      willChange: true,
      externalRAF: false,
      wrapperClass: 'imageWrapper'
    });

    // Store the instance for later reset
    parallaxInstances.push(ukiyoInstance);
  });

  // console.log("Ukiyo initialized");
}
function resetUkiyo() {
  // console.log("Resetting Ukiyo on resize...");

  parallaxInstances.forEach((instance) => {
    if (typeof instance.reset === "function") {
      instance.reset();
    }
  });
}
function isMobileDevice() {
  return window.innerWidth <= 768;
}
function navMenu() {
  const mainNavId = document.querySelector("#wrapper-navbar");
  const menu = document.querySelector(".main-navigation-menu");
  const menuButton = document.querySelector("#menu-navigation");
  const menuItems = menu.querySelectorAll(".mainMenu li"); // Select all list items
  const menuText = menuButton.querySelector('.menu-text');
  const featuredProjects = document.querySelectorAll(".menu-featured-project, .menu-featured-blog, .menuBottom");
  let menuOpen = false;

  menuButton.addEventListener("click", function () {
    menuButton.classList.toggle("active");
    if (mainNavId) {
      mainNavId.classList.toggle("menu-active");
    }
    if (menuOpen) {
      menuText.innerHTML = "Push to <br> Launch"
    } else {
      menuText.innerHTML = "Revert"
    }
    if (!menuOpen) {
      // Slide in from the right and fade in the menu
      gsap.to(menu, {
          x: "0%",
          opacity: 1,
          visibility: "visible",
          duration: 0.5,
          ease: "power3.out",
          onComplete: () => {
              // Stagger fade-in for menu items
              gsap.fromTo(menuItems,
                  { opacity: 0, y: 20 },
                  { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, ease: "power2.out" }
              );
              // Fade in featured project elements
              gsap.to(featuredProjects, {
                  opacity: 1,
                  duration: 0.6,
                  ease: "power2.out"
              });
          }
      });
    } else {
      // Fade out menu items first, then close the menu
      gsap.to(menuItems, {
          opacity: 0,
          y: 20,
          duration: 0.3,
          stagger: 0.05,
          ease: "power2.in"
      });

      // Fade out featured project elements
      gsap.to(featuredProjects, {
          opacity: 0,
          duration: 0.2,
          ease: "power3.in"
      });

      // Close the menu after items fade out
      gsap.to(menu, {
          delay: 0.2, // Ensures elements fade out first
          // y: "-100%",
          x: "100%",
          opacity: 0,
          duration: 0.5,
          ease: "power3.in",
          onComplete: () => {
              gsap.set(menu, { y: "0%", x: "100%", visibility: "hidden" }); // Reset position for next open
          }
      });
    }
    menuOpen = !menuOpen;
  });
}
function fadeNavbarOnScroll(navbarSelector) {
    const navbar = document.querySelector(navbarSelector);
    let lastScrollTop = 0;
    let isFaded = false;

    if (!navbar) return; // Ensure the navbar exists

    window.addEventListener("scroll", function () {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop <= 10) {
            // Always show navbar when at the top of the page
            navbar.style.opacity = "1";
            isFaded = false;
            return;
        }

        if (scrollTop > lastScrollTop) {
            // Scrolling down - fade out
            if (!isFaded) {
                navbar.style.transition = "opacity 0.5s ease-in-out";
                navbar.style.opacity = "0";
                isFaded = true;
            }
        } else {
            // Scrolling up - fade in
            if (isFaded) {
                navbar.style.transition = "opacity 0.5s ease-in-out";
                navbar.style.opacity = "1";
                isFaded = false;
            }
        }

        lastScrollTop = scrollTop;
    });
}
function collageLine(lineSelector, collageSelector, options = {}) {
  const lines = gsap.utils.toArray(lineSelector);
  const collage = document.querySelector(collageSelector);

  if (!collage) return;

  lines.forEach((line) => {
    gsap.set(line, { height: 0, top: "0", transformOrigin: "top" });

    // ScrollTrigger that updates height every frame
    ScrollTrigger.create({
      trigger: collage,
      start: options.start || "top bottom",
      end: options.end || "bottom top",
      scrub: 1, // Tight sync with scroll speed
      fastScrollEnd: true,
      invalidateOnRefresh: true, // Recalculate on resize
      markers: options.markers || false,
      onUpdate: (self) => {
        let progress = self.progress;
        let collageHeight = collage.offsetHeight;
        let viewportHeight = window.innerHeight;

        // Ensures the line grows exactly with scroll progress
        let newHeight = progress * (collageHeight + viewportHeight);

        gsap.set(line, { height: newHeight });
      },
    });
  });
  ScrollTrigger.refresh();
}
// Call the function after DOM has loaded
document.addEventListener("DOMContentLoaded", function () {
  collageLine(".collage-line", ".collage-top", {
    scrub: 1, // Ensures smooth but instant updates
    start: "top bottom",
    end: "bottom top",
    markers: false, // Debugging markers (disable in production)
  });
});

function animateHighlightedLines() {
  const highlightedItems = document.querySelectorAll('.highlighted-line');
  if (!highlightedItems) return;

  highlightedItems.forEach(item => {
    // Parse comma-separated values from data-highlight attribute
    // Fallback to the element's text content if not provided.
    const dataAttr = item.getAttribute('data-highlight');
    const values = dataAttr
      ? dataAttr.split(',').map(v => v.trim())
      : [item.textContent];

    let currentIndex = 0;
    let cycleInterval = null;
    let firstCycle = true; // Track the very first time entering view

    // Set the initial text and reset the highlight width to 0.
    item.textContent = values[currentIndex];
    item.style.setProperty('--highlight-width', '0%');
    gsap.set(item, { opacity: 1 });

    // Animate the highlight width from 0 to 100%.
    function animateHighlightIn() {
      item.style.setProperty('--highlight-width', '0%');
      gsap.to(item, {
        duration: 1,
        ease: "power2.out",
        "--highlight-width": "100%"
      });
    }

    // Animate the highlight width from its current state back to 0.
    function animateHighlightOut() {
      gsap.to(item, {
        duration: 0.5,
        ease: "power2.in",
        "--highlight-width": "0%"
      });
    }

    // Define the cycle animation: fade out & shrink highlight,
    // update text, then fade in & animate highlight back in.
    function cycleAnimation() {
      return gsap.timeline()
        .to(item, {
          duration: 0.5,
          opacity: 0,
          ease: "power2.in",
          "--highlight-width": "0%"
        })
        .add(() => {
          currentIndex = (currentIndex + 1) % values.length;
          item.textContent = values[currentIndex];
        })
        .to(item, { duration: 0.5, opacity: 1, ease: "power2.out" })
        .to(item, {
          duration: 1,
          ease: "power2.out",
          "--highlight-width": "100%"
        }, "<");
    }

    // Start the cycle (if there are multiple values). On the very first entry, animate in.
    function startCycle() {
      if (firstCycle) {
        animateHighlightIn();
        firstCycle = false;
      }
      if (!cycleInterval) {
        cycleInterval = setInterval(() => {
          cycleAnimation();
        }, 3000); // Cycle every 3 seconds (adjust as needed)
      }
    }

    // Stop the cycle (clears the timer).
    function stopCycle() {
      if (cycleInterval) {
        clearInterval(cycleInterval);
        cycleInterval = null;
      }
    }

    // Set up ScrollTrigger for elements with multiple values.
    if (values.length > 1) {
      ScrollTrigger.create({
        trigger: item,
        start: "top 80%",
        end: "bottom 20%",
        // On scrolling down into view, animate in the highlight and start cycling.
        onEnter: () => {
          startCycle();
          animateHighlightIn();
        },
        // Scrolling down out of view: stop cycling; leave highlight at full width.
        onLeave: () => {
          stopCycle();
        },
        // On scrolling back up into view, resume cycling without reanimating the highlight.
        onEnterBack: () => {
          startCycle();
        },
        // On scrolling up out of view, stop cycling and animate the highlight out.
        onLeaveBack: () => {
          stopCycle();
          animateHighlightOut();
        }
      });
    } else {
      // For a single value, just animate the highlight in on enter and animate it out when scrolling up out.
      ScrollTrigger.create({
        trigger: item,
        start: "top 80%",
        onEnter: animateHighlightIn,
        onEnterBack: animateHighlightIn,
        onLeaveBack: animateHighlightOut
      });
    }
  });
}
animateHighlightedLines();

function initHubHeroAnimations() {
  // Use GSAP's matchMedia to manage animations based on screen width
  let mm = gsap.matchMedia();

  // Hide .hub-hero completely on ≤ 675px via CSS
  function hideHeroOnSmallScreens() {
    const style = document.createElement("style");
    style.innerHTML = `
      @media (max-width: 675px) {
        .hub-hero {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  hideHeroOnSmallScreens(); // Apply the CSS rule
  // **Mobile Only: Simple fade-in animation**
  mm.add("(max-width: 675px)", () => {
    // Wait for everything to be ready, then fade in
    setTimeout(() => {
      const mobileHeroImage = document.querySelector(".hub-mobile-hero img.mobileHeader");
      const mobileHeroTopTitle = document.querySelector(".hub-mobile-hero .top-title");
      const mobileHeroTitle = document.querySelector(".hub-mobile-hero h1");

      if (!mobileHeroImage || !mobileHeroTopTitle) return;

      // Simple fade-in after page load
      gsap.to(mobileHeroImage, {
        opacity: 1,
        visibility: "visible",
        duration: 1.5,
        ease: "power2.out"
      });

      gsap.to(mobileHeroTopTitle, {
        '--highlight-width': '100%',
        duration: 1,
        ease: "power2.out",
      });
      
      gsap.to(mobileHeroTitle, {
        'opacity': '100%',
        duration: 1,
        ease: "power2.out",
      });
    }, 300); // Small delay to ensure page is fully loaded

    return () => {
      gsap.killTweensOf(".hub-mobile-hero img, .hub-mobile-hero .top-title, .hub-mobile-hero h1");
    };
  });
  mm.add("(min-width: 676px)", () => {
    let heroTriggers = []; // Store ScrollTriggers created in this function

    function adjustHeroHeight() {
      return new Promise((resolve) => {
        const heroSection = document.querySelector(".hub-hero");
        if (!heroSection) return resolve(); // Prevents errors if .hub-hero doesn't exist

        let newHeight;

        if (window.innerWidth >= 1440) {
          newHeight = window.innerHeight; // Full height on large screens
        } else {
          newHeight = Math.max(635, window.innerHeight * 0.8);
        }

        // Use CSS custom property instead of direct style manipulation
        document.documentElement.style.setProperty('--hero-height', `${newHeight}px`);
        
        // Fallback: Also set inline style with !important
        heroSection.style.setProperty('height', `${newHeight}px`, 'important');
        
        // Force recalculation
        heroSection.offsetHeight;

        requestAnimationFrame(() => setTimeout(resolve, 50));
      });
    }

    async function runHeroAnimations() {
      const heroImage = document.querySelector(".hub-hero img");
      const heroTitle = document.querySelector(".hub-hero-title-wrapper .title-wrap");
      const heroTopTitle = document.querySelector(".hub-hero-title-wrapper .title-wrap .top-title");

      if (!heroImage || !heroTitle) return;

      await adjustHeroHeight();

      gsap.set(heroImage, { opacity: 0, visibility: "hidden" });

      setTimeout(() => {
        gsap.to(heroImage, {
          opacity: 1,
          visibility: "visible",
          duration: 1.5,
          ease: "power2.out"
        });

        gsap.to(heroTopTitle, {
          '--highlight-width': '100%',
          duration: 1,
        });

        heroTriggers.push(
          gsap.fromTo(heroImage,
            { yPercent: 0 },
            {
              yPercent: 55,
              opacity: 0,
              duration: 2,
              ease: "power2.out",
              scrollTrigger: {
                trigger: '#herotrigger',
                toggleActions: 'play reverse play reverse',
                scrub: true,
              }
            }
          )
        );

        heroTriggers.push(
          gsap.fromTo(heroTitle,
            { y: 0, opacity: 1 },
            {
              y: 200,
              opacity: 0,
              duration: 1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: '#herotrigger',
                toggleActions: 'play reverse play reverse',
                scrub: true,
              }
            }
          )
        );
      }, 100);
    }

    if (document.querySelector('.hub-hero')) {
      window.addEventListener("resize", adjustHeroHeight);
      adjustHeroHeight();
      runHeroAnimations();
    }

    // Cleanup function: Only remove ScrollTriggers created in this function
    return () => {
      // console.log("Cleaning up animations for `.hub-hero` only");
      gsap.killTweensOf(".hub-hero img, .hub-hero-title-wrapper .title-wrap");
      // const targets = document.querySelectorAll(".hub-hero img, .hub-hero-title-wrapper .title-wrap");
      // if (targets.length) {
      //   gsap.killTweensOf(targets);
      // }

      // Only kill ScrollTriggers if they exist
      heroTriggers.forEach(trigger => {
        if (trigger.scrollTrigger) {
          trigger.scrollTrigger.kill();
        }
      });

      heroTriggers = [];
    };
  });
}

function reelCarousel() {
  let userClickedSlide = false;
  // If an existing Swiper instance exists, destroy it
  if (window.reelSwiper && typeof window.reelSwiper.destroy === "function") {
      window.reelSwiper.destroy(true, true);
      window.reelSwiper = null;
      console.log("Destroyed previous reelSwiper instance.");
  }

  // Create a new Swiper instance and store it both locally and globally
  const swiper = new Swiper(".pre-footer-carousel", {
      direction: "horizontal",
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      watchSlidesProgress: true,
      allowSlideNext: true,
      allowSlidePrev: true,
      allowTouchMove: true,
      speed: 600,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
      },
      on: {
          init: function () {
              setupPlayButtons();
              setupSlideClick(this);
              preloadNextVideos(this);
              observeSection(this);
          },
          slideChangeTransitionStart: function () {
              console.log("slideChangeTransitionStart - active index:", this.activeIndex, "real index:", this.realIndex);
              pauseInactiveVideos(this);
          },
          slideChangeTransitionEnd: function () {
              console.log("slideChangeTransitionEnd - active index:", this.activeIndex, "real index:", this.realIndex);
              pauseInactiveVideos(this);
              preloadNextVideos(this);
              if (userClickedSlide) {
                  playActiveVideo(this);
                  userClickedSlide = false;
              }
          },
      },
  });

  // Store the instance globally for later reference
  window.reelSwiper = swiper;

  // Helper functions below remain unchanged
  function setupPlayButtons() {
      document.querySelectorAll(".pre-footer-carousel .swiper-slide").forEach(slide => {
          const video = slide.querySelector("video");
          const playButton = slide.querySelector(".play-button");
          if (!video || !playButton) return;
          playButton.addEventListener("click", (event) => {
              event.stopPropagation();
              if (slide.classList.contains("swiper-slide-active")) {
                  video.classList.remove("video-hidden");
                  video.play();
                  playButton.classList.add("hidden");
                  console.log("Play button clicked on active slide.");
              }
          });
          video.addEventListener("click", (event) => {
              event.stopPropagation();
              if (!video.paused) {
                  video.pause();
                  playButton.classList.remove("hidden");
                  console.log("Video clicked and paused.");
              }
          });
          video.addEventListener("pause", () => {
              if (slide.classList.contains("swiper-slide-active")) {
                  playButton.classList.remove("hidden");
              }
          });
          video.addEventListener("ended", () => {
              playButton.classList.remove("hidden");
              video.classList.add("video-hidden");
          });
          video.addEventListener("play", () => {
              playButton.classList.add("hidden");
          });
      });
  }

  function setupSlideClick(swiper) {
      document.querySelectorAll(".pre-footer-carousel .swiper-slide").forEach((slide) => {
          slide.addEventListener("click", function (event) {
              if (event.target.classList.contains("play-button")) return;
              const clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
              if (isNaN(clickedIndex)) return;
              const currentIndex = swiper.realIndex;
              if (clickedIndex !== currentIndex) {
                  userClickedSlide = true;
                  swiper.slideToLoop(clickedIndex, 600);
                  console.log("Slide clicked. Changing from real index", currentIndex, "to", clickedIndex);
              }
          });
      });
  }

  function preloadNextVideos(swiper) {
      const nextIndex = (swiper.realIndex + 1) % swiper.slides.length;
      const nextSlide = swiper.slides[nextIndex];
      const nextVideo = nextSlide ? nextSlide.querySelector("video") : null;
      if (nextVideo && nextVideo.readyState < 3) {
          nextVideo.load();
      }
  }

  function observeSection(swiper) {
      const section = document.querySelector(".pre-footer");
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              // Intersection logic can be added here if needed
          });
      }, { threshold: 0.5 });
      observer.observe(section);
  }

  function playActiveVideo(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      const video = activeSlide.querySelector("video");
      const playButton = activeSlide.querySelector(".play-button");
      if (video) {
          video.classList.remove("video-hidden");
          video.play();
          playButton.classList.add("hidden");
          console.log("Playing video on active slide.");
      }
  }

  function pauseInactiveVideos(swiper) {
      swiper.slides.forEach(slide => {
          if (!slide.classList.contains("swiper-slide-active")) {
              const video = slide.querySelector("video");
              if (video && !video.paused) {
                  video.pause();
                  video.currentTime = 0;
                  const playButton = slide.querySelector(".play-button");
                  if (playButton) {
                      playButton.classList.remove("hidden");
                  }
                  console.log("Paused and reset a video on an inactive slide.");
              }
          }
      });
  }

  swiper.update();
}

function initAllScripts() {
  navMenu();
  initUkiyo();
  const lenis = new Lenis({
    smooth: true,
    lerp: 0.07, // Adjust this for the right smoothness (higher = smoother, lower = responsive)
    wheelMultiplier: 0.6, // Prevents over-sensitive scrolling
    smoothTouch: true, // Enables smooth scrolling on touch devices
    touchMultiplier: 1.5, // Adjusted for a more natural mobile experience
    infinite: false, // No infinite looping
  });
  lenis.on("scroll", () => {
    ScrollTrigger.update(); // Ensures GSAP updates **only** on scroll
  });

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Ensures GSAP and Lenis are in sync
  });
  gsap.ticker.lagSmoothing(0); // Prevents lag spikes


  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  ////////////////// END LENIS ////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////


  document.addEventListener("DOMContentLoaded", animateHighlightedLines);

  fadeNavbarOnScroll("#wrapper-navbar");
  initWorkPieceHoverEffect();
  // Show Case Click
  handleShowcaseButtonClick();

  // ANIMATE INTERIOR HERO
  if (document.querySelector('.template-interior-page')) {
    animateInteriorHeroSection();
  }
  // CHECK FOR CASE STUY CAROUSEL AND RUN FUNCTION
  if (document.querySelector(".case-study-carousel")) {
    initializePinnedSwiper({
      swiperSelector: ".case-study-carousel",
      wrapperSelector: ".case-study-carousel-wrapper",
      paginationSelector: ".swiper-pagination",
      lineSelector: ".line-six .home__line",
      scrollDuration: 1600,
    });
  }
  if (document.querySelector('.video-proj')) {
    fadeUpAndControlVideo({
      start: "top 80%",
      end: "bottom 30%",
      duration: 1.5,
      ease: "power3.out",
      markers: false, // Set to true for debugging
    });
  }

  //full video
  // initializeVideoPlayer();

  // ANIMATE HIGHLIGHT TEXT
  animateHighlightText();

  // LINE ANIMATIONS
  newLineAnimation(".line", {
    transformOrigin: "top center",
    start: "top bottom",
    end: "top top",
    scrub: true,
    markers: false,
  });

  // FADE UP ANIMATION
  newFadeUpOnScroll("fade-up", {
    start: "top 90%",
    duration: 1.5,
    ease: "power3.out",
    markers: false, // Change to true for debugging
  });

  if (document.querySelector("#expertise-bg-one")) {
    newAnimateBgSvgPaths("#expertise-bg-one");
  }
  if (document.querySelector("#expertise-bg-two")) {
    newAnimateBgSvgPaths("#expertise-bg-two");
  }
  if (document.querySelector(".animated-svg-strategy")) {
    animateSvgPaths(".animated-svg-strategy", "#328ACA");
  }
  if (document.querySelector(".animated-svg-innovation")) {
    animateSvgPaths(".animated-svg-innovation", "#62BDAE");
  }
  if (document.querySelector(".section-six .animated-svg-results")) {
    animateSvgPaths(".section-six .animated-svg-results", "#328ACA");
  }
  if (document.querySelector(".work-piece .animated-svg-results-home")) {
    animateSvgPaths(".animated-svg-results-home", "#4F1D75");
  }
  if (document.querySelector(".animated-svg-results-home-mobile")) {
    animateSvgPaths(".animated-svg-results-home-mobile", "#4F1D75");
  }
  if (document.querySelector(".animated-exceed-icon")) {
    animateSvgPaths(".animated-exceed-icon", "#328ACA");
  }
  if (document.querySelector(".animated-rocket")) {
    animateSvgPaths(".animated-rocket", "#328ACA");
  }
  // CHECK FOR CAPABILITIES AND RUN FUNCTION
  if (document.querySelector(".capabilities-icon-block")) {
    capabilitiesWaveFadeIn();
  }
  // CHECK FOR CLIENT LOGOS AND FUN FUNCTION
  if (document.querySelector(".client-logos")) {
    clientLogoWaveFadeIn();
  }
  // CHECK FOR FULL VIDEO SECTION AND RUN FUNCTION
  if (document.querySelector(".full-video")) {
    initializeVideoPlayer({
      videoSelector: '#video-expectations',
      posterSelector: '#poster',
      buttonSelector: '#video-toggle'
    });
  }

  if (document.querySelector('.fans-for-life')) {
    FFLlineAnimation(".fans-for-life .line-six .home__line", {
      transformOrigin: "top center",
      start: "top bottom",
      end: "+=2100",
      scrub: 2,
      markers: false,
    });
  }

  if (document.querySelector('.line-six-mobile .home__line')) {
    FFLlineAnimation(".line-six-mobile .home__line", {
      transformOrigin: "top center",
      start: "top bottom",
      end: "top top",
      scrub: true,
      markers: false,
    });
  }


  if (document.querySelector('.case-study-stat-wrapper') || document.querySelector('.template-interior-page') || document.querySelector('.template-team')) {
    animateStats('.jsStat', 2000);
    statScroller();
  }

  if (document.querySelector('.quoteBottomSlider')) {
    var quoteBottomSlider = new Swiper(".quoteBottomSlider", {
      spaceBetween: 40,
      allowTouchMove: true, // Allow swiping
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        100: { slidesPerView: 1 },
        991: { slidesPerView: 2, allowTouchMove: true, autoHeight: true },
        1200: { slidesPerView: 3 },
        1525: { slidesPerView: 4 }
      },
      on: {
        slideChange: function () {
          syncSliders(quoteBottomSlider);
        },
        touchEnd: function () {
          syncSliders(quoteBottomSlider);
        },
        transitionEnd: function () {
          syncSliders(quoteBottomSlider);
        }
      }
    });

    var quoteTopSlider = new Swiper(".quoteTopSlider", {
      spaceBetween: 10,
      pagination: {
        el: ".carousel-dots",
        clickable: true,
      },
      thumbs: {
        swiper: quoteBottomSlider, // Links bottom slider as thumbnails
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 500, // Faster transition to match touch swiping
      on: {
        init: function () {
          syncPagination();
        },
        slideChange: function () {
          syncPagination();
          syncSliders(quoteTopSlider);
        }
      }
    });

    function syncSliders(activeSlider) {
      let activeIndex = activeSlider.realIndex;

      if (activeSlider === quoteBottomSlider && quoteTopSlider.realIndex !== activeIndex) {
        quoteTopSlider.slideTo(activeIndex, 500); // Ensures top slides when bottom is swiped
      } else if (activeSlider === quoteTopSlider && quoteBottomSlider.realIndex !== activeIndex) {
        quoteBottomSlider.slideTo(activeIndex, 500);
      }
    }

    function syncPagination() {
      const mainPagination = document.querySelector(".carousel-dots");
      const secondaryPagination = document.querySelector(".carousel-dots-mobile");
      if (mainPagination && secondaryPagination) {
        secondaryPagination.innerHTML = mainPagination.innerHTML;
        document.querySelectorAll(".carousel-dots .swiper-pagination-bullet, .carousel-dots-mobile .swiper-pagination-bullet")
        .forEach((dot, index) => {
          dot.addEventListener("click", () => {
            quoteTopSlider.slideTo(index);
          });
        });
      }
    }
  }


  if (document.querySelector('#custom-ws-form')) {
    const form = document.getElementById("custom-ws-form");
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      // Convert FormData to JSON
      let jsonData = {};
      formData.forEach((value, key) => {
        jsonData[key] = value;
      });

      fetch("/wp-json/ws-form/v1/submit/2", { // 🔥 Change "2" to your WS Form ID
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
      })
        .then(response => response.json())
        .then(data => {
          // console.log("WS Form Submission Success:", data);
          document.getElementById("ws-form-response").innerHTML = "<p>Form submitted successfully!</p>";
        })
        .catch(error => {
          console.error("WS Form Submission Error:", error);
          document.getElementById("ws-form-response").innerHTML = "<p>There was an error submitting the form.</p>";
        });
    });
  }

  jQuery(document).ready(function ($) {
    $("#contactForm-cp").on("submit", function (e) {
      e.preventDefault();

      let validationMessage = $(".validation-message");
      let submitButton = $("#contactForm-cp button[type='submit']");

      validationMessage.html(""); // Clear previous validation messages
      submitButton.prop("disabled", true).addClass("disabled"); // Disable button

      let first_name = $('input[name="first_name"]').val().trim();
      let last_name = $('input[name="last_name"]').val().trim();
      let email = $('input[name="email"]').val().trim();
      let phone = $('input[name="phone"]').val().trim();
      let message = $('textarea[name="message"]').val().trim();

      let errors = [];

      // ✅ Validate fields
      if (!first_name) errors.push("First name is required.");
      if (!last_name) errors.push("Last name is required.");
      if (!email) {
        errors.push("Email is required.");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push("Please enter a valid email address.");
      }
      if (!message) errors.push("Message is required.");

      // ❌ Show validation errors and stop submission if there are errors
      if (errors.length > 0) {
        validationMessage.html(`<div class="error">${errors.join("<br>")}</div>`);
        submitButton.prop("disabled", false).removeClass("disabled"); // Re-enable button
        return;
      }

      // ✅ If no errors, proceed with WS Form submission
      let wsFirstNameField = $('input[name="field_6"]');
      let wsLastNameField = $('input[name="field_11"]');
      let wsEmailField = $('input[name="field_7"]');
      let wsPhoneField = $('input[name="field_8"]');
      let wsMessageField = $('textarea[name="field_9"]');

      if (wsFirstNameField.length && wsEmailField.length && wsMessageField.length) {
        wsFirstNameField.val(first_name);
        wsLastNameField.val(last_name);
        wsEmailField.val(email);
        wsPhoneField.val(phone);
        wsMessageField.val(message);

        // ✅ Submit WS Form
        $("#ws-form-3").submit();

        // ✅ Show success message & clear inputs after submission
        setTimeout(() => {
          validationMessage.html('<div class="alert alert-blue-green text-dark">Your message has been sent successfully!</div>');

          // ✅ Clear input fields
          $('input[name="first_name"], input[name="last_name"], input[name="email"], input[name="phone"], textarea[name="message"]').val('');

          // ✅ Re-enable the submit button
          submitButton.prop("disabled", false).removeClass("disabled");

          // ✅ Remove success message after 5 seconds
          setTimeout(() => {
            $(".alert").fadeOut(500, function () {
              $(this).remove();
            });
          }, 5000);
        }, 1500); // ✅ Adjust delay as needed (1.5s)
      } else {
        console.error("WS Form fields not found.");
        validationMessage.html('<div class="error">An error occurred. Please try again.</div>');

        // ✅ Re-enable submit button if an error occurs
        submitButton.prop("disabled", false).removeClass("disabled");
      }
    });
  });

  jQuery(document).ready(function ($) {
    $("#contactForm-pre").on("submit", function (e) {
      e.preventDefault();

      let validationMessage = $(".validation-message");
      let submitButton = $("#contactForm-pre button[type='submit']");

      validationMessage.html(""); // Clear previous validation messages
      submitButton.prop("disabled", true).addClass("disabled"); // Disable button

      let name = $('input[name="full_name"]').val().trim();
      let email = $('input[name="email"]').val().trim();
      let phone = $('input[name="phone"]').val().trim();
      let message = $('textarea[name="message"]').val().trim();

      let errors = [];

      // ✅ Validate fields
      if (!name) errors.push("Name is required.");
      if (!email) {
        errors.push("Email is required.");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push("Please enter a valid email address.");
      }
      if (!message) errors.push("Message is required.");

      // ❌ Show validation errors and stop submission if there are errors
      if (errors.length > 0) {
        validationMessage.html(`<div class="error">${errors.join("<br>")}</div>`);
        submitButton.prop("disabled", false).removeClass("disabled"); // Re-enable button
        return;
      }

      // ✅ If no errors, proceed with WS Form submission
      let wsNameField = $('input[name="field_1"]');
      let wsEmailField = $('input[name="field_2"]');
      let wsPhoneField = $('input[name="field_3"]');
      let wsMessageField = $('textarea[name="field_4"]');

      if (wsNameField.length && wsEmailField.length && wsMessageField.length) {
        wsNameField.val(name);
        wsEmailField.val(email);
        wsPhoneField.val(phone);
        wsMessageField.val(message);
        $("#ws-form-1").submit();
        setTimeout(() => {
          validationMessage.html('<div class="alert alert-blue-green text-dark">Your message has been sent successfully!</div>');

          $('input[name="full_name"], input[name="email"], input[name="phone"], textarea[name="message"]').val('');

          submitButton.prop("disabled", false).removeClass("disabled");

          setTimeout(() => {
            $(".alert").fadeOut(500, function () {
              $(this).remove();
            });
          }, 5000);
        }, 1500);
      } else {
        console.error("WS Form fields not found.");
        validationMessage.html('<div class="error">An error occurred. Please try again.</div>');

        submitButton.prop("disabled", false).removeClass("disabled");
      }
    });
  });


  if (document.querySelector('.hub-hero')) {
    // function initHubHeroAnimations() {
    //   // Use GSAP's matchMedia to manage animations based on screen width
    //   let mm = gsap.matchMedia();

    //   // Hide .hub-hero completely on ≤ 675px via CSS
    //   function hideHeroOnSmallScreens() {
    //     const style = document.createElement("style");
    //     style.innerHTML = `
    //       @media (max-width: 675px) {
    //         .hub-hero {
    //           display: none !important;
    //           visibility: hidden !important;
    //           opacity: 0 !important;
    //         }
    //       }
    //     `;
    //     document.head.appendChild(style);
    //   }

    //   hideHeroOnSmallScreens(); // Apply the CSS rule
    //   // **Mobile Only: Run Highlight Animation on `.hub-mobile-hero`**
    //   mm.add("(max-width: 675px)", () => {
    //     const mobileHeroTopTitle = document.querySelector(".hub-mobile-hero .top-title");
    //     const mobileHeroTitle = document.querySelector(".hub-mobile-hero h1");

    //     if (!mobileHeroTopTitle) return;

    //     gsap.to(mobileHeroTopTitle, {
    //       '--highlight-width': '100%',
    //       duration: 1,
    //       ease: "power2.out",
    //     });
    //     gsap.to(mobileHeroTitle, {
    //       'opacity': '100%',
    //       duration: 1,
    //       ease: "power2.out",
    //     });

    //     return () => {
    //       console.log("Cleaning up highlight animation for `.hub-mobile-hero`");
    //       gsap.killTweensOf(mobileHeroTopTitle);
    //     };
    //   });
    //   mm.add("(min-width: 676px)", () => {
    //     let heroTriggers = []; // Store ScrollTriggers created in this function

    //     function adjustHeroHeight() {
    //       return new Promise((resolve) => {
    //         const heroSection = document.querySelector(".hub-hero");
    //         if (!heroSection) return resolve(); // Prevents errors if .hub-hero doesn't exist

    //         let newHeight;

    //         if (window.innerWidth >= 1440) {
    //           newHeight = window.innerHeight; // Full height on large screens
    //         } else {
    //           newHeight = Math.max(635, window.innerHeight * 0.8);
    //         }

    //         heroSection.style.height = `${newHeight}px`;

    //         requestAnimationFrame(() => setTimeout(resolve, 50));
    //       });
    //     }

    //     async function runHeroAnimations() {
    //       const heroImage = document.querySelector(".hub-hero img");
    //       const heroTitle = document.querySelector(".hub-hero-title-wrapper .title-wrap");
    //       const heroTopTitle = document.querySelector(".hub-hero-title-wrapper .title-wrap .top-title");

    //       if (!heroImage || !heroTitle) return;

    //       await adjustHeroHeight();

    //       gsap.set(heroImage, { opacity: 0, visibility: "hidden" });

    //       setTimeout(() => {
    //         gsap.to(heroImage, {
    //           opacity: 1,
    //           visibility: "visible",
    //           duration: 1.5,
    //           ease: "power2.out"
    //         });

    //         gsap.to(heroTopTitle, {
    //           '--highlight-width': '100%',
    //           duration: 1,
    //         });

    //         heroTriggers.push(
    //           gsap.fromTo(heroImage,
    //             { yPercent: 0 },
    //             {
    //               yPercent: 55,
    //               opacity: 0,
    //               duration: 2,
    //               ease: "power2.out",
    //               scrollTrigger: {
    //                 trigger: '#herotrigger',
    //                 toggleActions: 'play reverse play reverse',
    //                 scrub: true,
    //               }
    //             }
    //           )
    //         );

    //         heroTriggers.push(
    //           gsap.fromTo(heroTitle,
    //             { y: 0, opacity: 1 },
    //             {
    //               y: 200,
    //               opacity: 0,
    //               duration: 1,
    //               ease: "power2.out",
    //               scrollTrigger: {
    //                 trigger: '#herotrigger',
    //                 toggleActions: 'play reverse play reverse',
    //                 scrub: true,
    //               }
    //             }
    //           )
    //         );
    //       }, 100);
    //     }

    //     if (document.querySelector('.hub-hero')) {
    //       window.addEventListener("resize", adjustHeroHeight);
    //       adjustHeroHeight();
    //       runHeroAnimations();
    //     }

    //     // Cleanup function: Only remove ScrollTriggers created in this function
    //     return () => {
    //       console.log("Cleaning up animations for `.hub-hero` only");
    //       gsap.killTweensOf(".hub-hero img, .hub-hero-title-wrapper .title-wrap");

    //       // Only kill ScrollTriggers if they exist
    //       heroTriggers.forEach(trigger => {
    //         if (trigger.scrollTrigger) {
    //           trigger.scrollTrigger.kill();
    //         }
    //       });

    //       heroTriggers = [];
    //     };
    //   });
    // }
    initHubHeroAnimations();
  }





  reelCarousel();


  teamTopContentCarousel();
  teamTitleHighlight();
}
initAllScripts();

window.addEventListener("resize", () => {
  resetUkiyo();
  if (!isMobileDevice()) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  ScrollTrigger.refresh();
});





// contact form submit - contact page
jQuery(document).ready(function ($) {
  $("#contactForm-cp").on("submit", function (e) {
    e.preventDefault();

    let validationMessage = $(".validation-message");
    let submitButton = $("#contactForm-cp button[type='submit']");

    validationMessage.html(""); // Clear previous validation messages
    submitButton.prop("disabled", true).addClass("disabled"); // Disable button

    let first_name = $('input[name="first_name"]').val().trim();
    let last_name = $('input[name="last_name"]').val().trim();
    let email = $('input[name="email"]').val().trim();
    let phone = $('input[name="phone"]').val().trim();
    let message = $('textarea[name="message"]').val().trim();

    let errors = [];

    // ✅ Validate fields
    if (!first_name) errors.push("First name is required.");
    if (!last_name) errors.push("Last name is required.");
    if (!email) {
      errors.push("Email is required.");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.push("Please enter a valid email address.");
    }
    if (!message) errors.push("Message is required.");

    // ❌ Show validation errors and stop submission if there are errors
    if (errors.length > 0) {
      validationMessage.html(`<div class="error">${errors.join("<br>")}</div>`);
      submitButton.prop("disabled", false).removeClass("disabled"); // Re-enable button
      return;
    }

    // ✅ If no errors, proceed with WS Form submission
    let wsFirstNameField = $('input[name="field_6"]');
    let wsLastNameField = $('input[name="field_11"]');
    let wsEmailField = $('input[name="field_7"]');
    let wsPhoneField = $('input[name="field_8"]');
    let wsMessageField = $('textarea[name="field_9"]');

    if (wsFirstNameField.length && wsEmailField.length && wsMessageField.length) {
      wsFirstNameField.val(first_name);
      wsLastNameField.val(last_name);
      wsEmailField.val(email);
      wsPhoneField.val(phone);
      wsMessageField.val(message);

      // ✅ Submit WS Form
      $("#ws-form-3").submit();

      // ✅ Show success message & clear inputs after submission
      setTimeout(() => {
        validationMessage.html('<div class="alert alert-blue-green text-dark">Your message has been sent successfully!</div>');

        // ✅ Clear input fields
        $('input[name="first_name"], input[name="last_name"], input[name="email"], input[name="phone"], textarea[name="message"]').val('');

        // ✅ Re-enable the submit button
        submitButton.prop("disabled", false).removeClass("disabled");

        // ✅ Remove success message after 5 seconds
        setTimeout(() => {
          $(".alert").fadeOut(500, function () {
            $(this).remove();
          });
        }, 5000);
      }, 1500); // ✅ Adjust delay as needed (1.5s)
    } else {
      console.error("WS Form fields not found.");
      validationMessage.html('<div class="error">An error occurred. Please try again.</div>');

      // ✅ Re-enable submit button if an error occurs
      submitButton.prop("disabled", false).removeClass("disabled");
    }
  });
});

/// AJAX TRANSITION LOADER
jQuery(document).ready(function ($) {
  var linkSelector = "a.ajax-link";
  var contentWrapper = '[data-loader="wrap"]'; // Main content container (DOES NOT REPLACE HEADER/FOOTER)
  var loader = $("#page-transition"); // Loader element selector

  // 🎬 Initialize Lottie Animation for Page Transitions
  let lottiePageTransition = null;
  
  function initLottieAnimation() {
    const container = document.getElementById('lottie-transition');
    if (container && typeof lottie !== 'undefined') {
      lottiePageTransition = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: 'https://lottie.host/e1da029b-8bf6-462a-a8ef-cb2da2762794/ImtM1GiqIB.json',
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      });
      
      // Make it globally accessible
      window.lottiePageTransition = lottiePageTransition;
      console.log('✅ Lottie page transition initialized');
    } else {
      console.warn('⚠️ Lottie container or library not found');
    }
  }
  
  // Initialize when document is ready and lottie library is available
  if (typeof lottie !== 'undefined') {
    initLottieAnimation();
  } else {
    // Wait for lottie library to load
    const checkLottie = setInterval(() => {
      if (typeof lottie !== 'undefined') {
        clearInterval(checkLottie);
        initLottieAnimation();
      }
    }, 100);
  }


  // 🚫 OLD TUNNEL ANIMATION - COMMENTED OUT BUT KEPT FOR REFERENCE
  /*
  function playTunnelAnimation(newContent, newTitle, newTemplateClass, targetUrl) {
      const paths = $("#page-transition path").toArray();
      const timeline = gsap.timeline();

      gsap.set("#page-transition", {
          scale: 1,
          opacity: 1,
          display: "flex",
          transformOrigin: "center center",
          y: "0%",
      });

      gsap.set(["#logo-animate", "#augustine-logo"], {
          scale: 0,
          opacity: 0,
          transformOrigin: "center center",
      });

      gsap.set("#center", {
          scale: 0,
          opacity: 0,
          transformOrigin: "center center",
      });

      paths.forEach((path, index) => {
          timeline.fromTo(
              path,
              { scale: 0.1, opacity: 1, transformOrigin: "center" },
              { scale: 3, opacity: 0, duration: 0.6, ease: "power1.inOut" },
              index * 0.2 // Stagger reduced
          );
      });

      timeline.to("#logo-animate", { scale: 1, opacity: 1, duration: 0.6, ease: "power2.out" }, paths.length * 0.2 - 0.5);
      timeline.to("#center", { scale: 50, opacity: 1, duration: 1.0, ease: "power2.out" }, paths.length * 0.2);
      timeline.to("#augustine-logo", { scale: 1, opacity: 1, duration: 0.6, ease: "power2.out" }, paths.length * 0.2 + 0.2);

      timeline.to("#page-transition", {
          y: "-100%",
          opacity: 0,
          duration: 0.7, // Faster exit animation
          ease: "power2.inOut",
          onComplete: () => {
              // console.log("✅ Replacing main content...");
            // In your AJAX onComplete callback after inserting new content:
            $(contentWrapper).html(newContent).fadeIn(300, function() {
              if (newTemplateClass) {
                $(contentWrapper).attr('class', newTemplateClass);
              }
              // Clean up any previous ScrollTriggers if necessary
              ScrollTrigger.getAll().forEach(trigger => trigger.kill());
              // Reinitialize your scripts after content is in place
              initAllScripts();

              animateHighlightedLines();
              // initHubHeroAnimations(); // Removed - already called in initAllScripts()
              collageLine(".collage-line", ".collage-top", {
                  scrub: 1,
                  start: "top bottom",
                  end: "bottom top",
                  markers: false,
              });
              ScrollTrigger.refresh();
            });

              // $(contentWrapper).html(newContent).fadeIn(300);

              // if (newTemplateClass) {
              //     $(contentWrapper).attr('class', newTemplateClass);
              // }

              // initAllScripts();
              // ScrollTrigger.refresh();

              // collageLine(".collage-line", ".collage-top", {
              //     scrub: 1,
              //     start: "top bottom",
              //     end: "bottom top",
              //     markers: false,
              // });
              document.title = newTitle;
              history.pushState(null, null, targetUrl);
          },
      });
  }
  */

  // 🎬 NEW Lottie Page Transition Function
  function playLottiePageTransition(newContent, newTitle, newTemplateClass, targetUrl) {
    const container = document.getElementById('lottie-transition');
    
    if (!container) {
      console.error("❌ Lottie transition container not found");
      // Fallback to direct content replacement
      $(contentWrapper).html(newContent).fadeIn(300, function() {
        if (newTemplateClass) {
          $(contentWrapper).attr('class', newTemplateClass);
        }
        initAllScripts();
        ScrollTrigger.refresh();
      });
      document.title = newTitle;
      history.pushState(null, null, targetUrl);
      return;
    }

    // Show the Lottie container
    container.classList.add('active');
    
    // Get the global animation instance from footer
    if (typeof window.lottiePageTransition !== 'undefined' && window.lottiePageTransition) {
      // Play the animation
      window.lottiePageTransition.goToAndPlay(0);
      
      // Handle animation completion
      const onComplete = () => {
        // Content replacement logic (same pattern as tunnel animation)
        $(contentWrapper).html(newContent).fadeIn(300, function() {
          if (newTemplateClass) {
            $(contentWrapper).attr('class', newTemplateClass);
          }
          // Clean up any previous ScrollTriggers if necessary
          ScrollTrigger.getAll().forEach(trigger => trigger.kill());
          // Reinitialize your scripts after content is in place
          initAllScripts();

          animateHighlightedLines();
          collageLine(".collage-line", ".collage-top", {
              scrub: 1,
              start: "top bottom",
              end: "bottom top",
              markers: false,
          });
          ScrollTrigger.refresh();
        });

        document.title = newTitle;
        history.pushState(null, null, targetUrl);
        
        // Hide the Lottie container after a delay
        setTimeout(() => {
          container.classList.remove('active');
        }, 300);
        
        // Remove the event listener
        window.lottiePageTransition.removeEventListener('complete', onComplete);
      };
      
      // Add completion listener
      window.lottiePageTransition.addEventListener('complete', onComplete);
    } else {
      console.error("❌ Lottie animation not found, using fallback");
      container.classList.remove('active');
      // Fallback to direct content replacement
      $(contentWrapper).html(newContent).fadeIn(300, function() {
        if (newTemplateClass) {
          $(contentWrapper).attr('class', newTemplateClass);
        }
        initAllScripts();
        ScrollTrigger.refresh();
      });
      document.title = newTitle;
      history.pushState(null, null, targetUrl);
    }
  }


  // 🔥 Click Event for AJAX Page Load
  $(document).on("click", linkSelector, function (e) {
    e.preventDefault();
    const targetUrl = $(this).attr("href");

    // console.log(`🔍 Fetching content from: ${targetUrl}`);

    fetch(targetUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, "text/html");

        const newContent = doc.querySelector(contentWrapper)?.innerHTML || "";
        const newTitle = doc.querySelector("title")?.innerText || document.title;
        const newTemplateClass = doc.querySelector(contentWrapper)?.getAttribute('class') || "";

        if (!newContent) {
          console.error("❌ Error: No content found in response.");
          alert("Failed to load the page. Please try again.");
          return;
        }

        // ✅ Fade out current content, start Lottie animation
        $(contentWrapper).fadeOut(300);
        setTimeout(() => {
          playLottiePageTransition(newContent, newTitle, newTemplateClass, targetUrl);
        }, 300);
      })
      .catch((error) => {
        console.error("❌ AJAX Load Error:", error);
        alert("Failed to load the page. Please try again.");
      });
  });

  // 🔄 Handle Back/Forward Navigation - NOW USING LOTTIE ANIMATION
  window.onpopstate = function () {
    const currentUrl = location.href;
    // console.log(`🔄 Handling back/forward navigation: ${currentUrl}`);

    fetch(currentUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, "text/html");

        const newContent = doc.querySelector(contentWrapper)?.innerHTML || "";
        const newTitle = doc.querySelector("title")?.innerText || document.title;
        const newTemplateClass = doc.querySelector(contentWrapper)?.getAttribute('class') || "";

        if (!newContent) {
          console.error("❌ Error: No content found.");
          return;
        }

        // Use Lottie animation for back/forward navigation too
        $(contentWrapper).fadeOut(300);
        setTimeout(() => {
          playLottiePageTransition(newContent, newTitle, newTemplateClass, currentUrl);
        }, 300);
      })
      .catch((error) => {
        console.error("❌ Popstate Load Error:", error);
        alert("Failed to load the page. Please try again.");
      });
  };
});










// new animation here